export default __webpack_public_path__ + "static/electrical_panel_w.fede3acf786d0d369b3fe4038578da9f.png";